class OrderHelper {
  constructor() {}

  /**
	 * Заполняет шаблон билета данными
	 * @param $ticket
	 * @param data {Object} - {
	 *   sector or view_id,
	 *   sid or id,
	 *   event_id,
	 *   row,
	 *   col,
	 *   price
	 * }

	 */

  insertDataToTicket($ticket, data) {
    const hasAdditionalTickets = data.additionalTickets && data.additionalTickets.length > 0;
    const hasAdditionServices = data.additionalServices && data.additionalServices.length > 0;
    function getTotalAdditionalTicketsPrice(data) {
      if (!data.additionalTickets || !Array.isArray(data.additionalTickets) || data.additionalTickets.length === 0) {
          return 0;
      }
      return data.additionalTickets.reduce((sum, ticket) => sum + ticket.price, 0);
    }

    const sector = data.sector || '';
    const sid = data.sid || data.id;
    const currentEventId = data.event_id;
    const priceId = data.price_view_id || data.price_id;
    const name = data.name || `Ряд ${data.row} место ${data.col}`;
    const ticketClassName = null;
    $ticket.find('.js-ticket-price').text(data.price !== undefined ? data.price + getTotalAdditionalTicketsPrice(data) : '');
    $ticket.find('.js-ticket-sector').text(sector)
    !data.is_pack && !data.hide ? $ticket.find('.js-ticket-place').text(name) : '';

    if (hasAdditionalTickets) {
      const additionalTicketsData = JSON.stringify(data.additionalTickets);
      const additionalServicesData = JSON.stringify(data.additionalServices);
      const additionalTicketsCount = data.additionalTickets.length;
      const labelAdditionalTickets = additionalTicketsCount > 1
      ? 'Услуги добавлены'
      : 'Услуга добавлена';

      $ticket.find('.js-ticket-service')
        .html(`
          <svg width="16" height="16">
              <use xlink:href="#service-added"></use>
          </svg>
          <span>
            ${labelAdditionalTickets}
          </span>
        `)
        .addClass('additional-services__added-service js-additional-services')
        .attr('data-id', data.additionalTickets[0].id)
        .attr('data-uid', data.additionalTickets[0].uid)
        .attr('data-parent-id', data.uid)
        .attr('data-order-id', data.orderId)
        .attr('additional-tickets-data', additionalTicketsData)
        .attr('additional-services-data', additionalServicesData);

    } else if (hasAdditionServices && data.additionalTickets.length === 0) {

      const $button = $('<button>')
        .addClass('btn-class js-additional-services') // добавление класса кнопке
        .html(`
          <svg width="16" height="16" aria-hidden="true" focusable="false">
              <use xlink:href="#service-add"></use>
          </svg>
          <span>
            Добавить услугу
          </span>
        `)
        .addClass('additional-services__add-service')
        .attr('data-parent-id', data.uid)
        .attr('data-order-id', data.order_id);

        const additionalServicesData = JSON.stringify(data.additionalServices);
        $button.attr('additional-services-data', additionalServicesData);

      $ticket.find('.js-ticket-service').append($button);
    }

    $ticket
      .find('.tickets__item')
      .attr('data-place', sid)
      .attr('data-uid', data.uid)
      .attr('data-id', data.id)
      .attr('data-price-id', priceId)
      .attr('data-event', currentEventId)
      .addClass(ticketClassName);

    return $ticket;
  }
}

export const orderHelper = new OrderHelper();
